import React, { useState, useEffect } from 'react';
import './ExportPortfolio.css';
import { useLanguage } from '../../context/LanguageContext';

const ExportPortfolio = () => {
  const { t, lang } = useLanguage();
  const [translatedData, setTranslatedData] = useState({});

  // KANKA SİHİRLİ ÇEVİRİ MOTORU
  const translateText = async (text, targetLang) => {
    if (!text || targetLang === 'TR') return text;
    
    const cacheKey = `${text}_${targetLang}`;
    if (translatedData[cacheKey]) return translatedData[cacheKey];

    try {
      const response = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=tr&tl=${targetLang.toLowerCase()}&dt=t&q=${encodeURI(text)}`
      );
      const data = await response.json();
      const result = data[0][0][0];
      
      setTranslatedData(prev => ({ ...prev, [cacheKey]: result }));
      return result;
    } catch (error) {
      return text; 
    }
  };

  const portfolioItems = [
    { title: "Resmi Kurumlar ve İhaleler", desc: "Teknik föy, analiz, ruhsat numarası, ambalaj ve ürün dosyasıyla sunulabilir yapı." },
    { title: "Veteriner Hekimler", desc: "Hayvan türüne ve saha ihtiyacına göre ayrılmış teknik destek ürünleri." },
    { title: "Afrika ve Balkanlar", desc: "İhracat pazarları için çok dilli ürün tanıtımı ve geniş portföy sunumu." },
    { title: "Arap Pazarı ve Deve Ürünleri", desc: "Deve premiksi, elektrolit ve kondisyon destek ürünleriyle ayrı pazar dili." }
  ];

  // Dil değiştikçe kart içeriklerini çeviriyoruz kanka
  useEffect(() => {
    if (lang !== 'TR') {
      portfolioItems.forEach(item => {
        translateText(item.title, lang);
        translateText(item.desc, lang);
      });
    }
  }, [lang]);

  const getDisplay = (originalText) => {
    const cacheKey = `${originalText}_${lang}`;
    return translatedData[cacheKey] || originalText;
  };

  return (
    <section className="export-portfolio-section" id="export-portfolio-anchor">
      <div className="portfolio-container">
        <div className="portfolio-header">
          <div className="badge-center">
            {/* Sabit badge çevirisi */}
            <span className="portfolio-badge">{t('catalog.export.badge')}</span>
          </div>
          {/* Ana başlık ve alt metin translations.js'den de gelebilir, buradan anlık da çevrilebilir */}
          <h2 className="portfolio-main-title">
            {t('catalog.export.mainTitle')}
          </h2>
          <p className="portfolio-subtitle">
            {t('catalog.export.subtitle')}
          </p>
        </div>

        <div className="portfolio-grid">
          {portfolioItems.map((item, index) => (
            <div className="portfolio-card" key={index}>
              {/* Kart başlıkları ve açıklamaları anlık çevriliyor */}
              <h3 className="p-card-title">{getDisplay(item.title)}</h3>
              <p className="p-card-desc">{getDisplay(item.desc)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExportPortfolio;